export default __webpack_public_path__ + "static/media/Roboto-Bold.3f2cbde6.woff";